import React from 'react'

//starting with capital letter will ensure this is treated as a component
const BomGridItemD = ({formObject, viewData, rowKey}) => {

    const renderValue = (value) => {
        if(value !== "0"){
            return value;
        }
        else{
            return "-";
        }    
    }

    return (
        <div className="saras-cell">
            <ul className="uiSearchSubList">
                {Object.values(viewData.childRows).map((row,index)=>(
                    <li>
                        <span className="sItemID">{row.rowValues.bomName.valF}</span>
                        <span className="sBomWeight">{renderValue(row.rowValues.bomMaterialValue.valF)} ({row.rowValues.bomMaterialCount.valF})</span>
                        <span className="sBomWeight">{renderValue(row.rowValues.bomProcessValue.valF)} ({row.rowValues.bomProcessCount.valF})</span>
                        <span className="sBomWeight">{renderValue(row.rowValues.bomTotalValue.valF)}</span>
                    </li>
                ))
                }
            </ul>
        </div>
    );
}

export default BomGridItemD
